/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

// Diverge del legacy a propósito (bugs corregidos): brillo_planetario2 usa
// pixelsPlanetario (el legacy no compilaba), los segmentos no restan 1 porque el
// dropdown ya es 0-based, y las dos matrices comparten key para no duplicar `matrix`.

const installPlanetario = (generator) => {
  generator.definitions_.neopixel_planetario = `
#include <Adafruit_NeoPixel.h>
#define PINPLANETARIO 7
#define NUMPIXELSPLANETARIO 70
Adafruit_NeoPixel pixelsPlanetario(NUMPIXELSPLANETARIO, PINPLANETARIO, NEO_GRB + NEO_KHZ800);
`;
  generator.setups_.BHOOT_led_neopixel_planetario_begin = `
pixelsPlanetario.begin();
pixelsPlanetario.clear();
`;
};

export const ARDUINOUNO_salidas_led_brillo_planetario = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  const led = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC) || 0;
  installPlanetario(generator);
  return `
pixelsPlanetario.setPixelColor(${led}, pixelsPlanetario.Color(${color}));
pixelsPlanetario.show();
delayMicroseconds(300);
`;
};

export const ARDUINOUNO_salidas_led_brillo_planetario2 = (block, generator) => {
  installPlanetario(generator);
  return 'pixelsPlanetario.clear();\npixelsPlanetario.show();\ndelayMicroseconds(300);\n';
};

export const ARDUINOUNO_salidas_led_brillo_planetario_clear = (block, generator) => {
  const led = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC) || 0;
  installPlanetario(generator);
  return `
pixelsPlanetario.setPixelColor(${led}, pixelsPlanetario.Color(0,0,0));
pixelsPlanetario.show();
delayMicroseconds(300);
`;
};

export const BHOOT_led_neopixel_planetario = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  const led = block.getFieldValue('LED') || '0';
  installPlanetario(generator);
  generator.definitions_.BHOOT_led_neopixel_planetario = `
void prenderLedSegmento(int segmento,int r,int g,int b) {
  int cantidadLedsPorSegmento = 7;
  int desde = cantidadLedsPorSegmento * segmento;
  int hasta = desde + cantidadLedsPorSegmento;
  for (int i = desde; i < hasta; i++) {
    pixelsPlanetario.setPixelColor(i, pixelsPlanetario.Color(r, g, b));
  }
  pixelsPlanetario.show();
  delayMicroseconds(300);
}
`;
  generator.setups_.BHOOT_led_neopixel_planetario = '\npixelsPlanetario.show();\n';
  return `\nprenderLedSegmento(${led},${color});\n`;
};

export const BHOOT_led_neopixel_clear_planetario = (block, generator) => {
  const led = block.getFieldValue('LED') || '0';
  installPlanetario(generator);
  generator.definitions_.BHOOT_led_neopixel_clear_planetario = `
void apagarLedSegmento(int segmento) {
  int cantidadLedsPorSegmento = 7;
  int desde = cantidadLedsPorSegmento * segmento;
  int hasta = desde + cantidadLedsPorSegmento;
  for (int i = desde; i < hasta; i++) {
    pixelsPlanetario.setPixelColor(i, pixelsPlanetario.Color(0, 0, 0));
  }
  pixelsPlanetario.show();
  delayMicroseconds(300);
}
`;
  return `\napagarLedSegmento(${led});\n`;
};

const installMatrizCiudad = (generator) => {
  generator.definitions_.matriz_ciudad_planetario = `
#include <SPI.h>
#include <Adafruit_GFX.h>
#include <Max72xxPanel.h>

const int pinCS = 49;
const int numberOfHorizontalDisplays = 6;
const int numberOfVerticalDisplays = 1;
Max72xxPanel matrix = Max72xxPanel(pinCS, numberOfHorizontalDisplays, numberOfVerticalDisplays);

void escribirMensajeMatrizPlanetario(String cadena, int velocidad) {
  int tamFuente = 6;
  int spacer = 1;
  static int pixel;
  static int desplazamiento = matrix.width()-1;
  int tamMensaje = tamFuente * cadena.length() + matrix.width() - 1 - spacer;

  matrix.fillScreen(LOW);
  if (pixel < tamMensaje) {
    int letter = pixel / tamFuente;
    int x = desplazamiento;
    int y = (matrix.height() - 8) / 2;
    while (x + tamFuente - spacer >= 0 && letter >= 0) {
      if (letter < cadena.length()) {
        matrix.drawChar(x, y, cadena[letter], HIGH, LOW, 1);
      }
      letter--;
      x -= tamFuente;
    }
    matrix.write();
    delay(velocidad);
    pixel++;
    if (desplazamiento > matrix.width() - tamFuente) {
      desplazamiento--;
    } else {
      desplazamiento = matrix.width()-1;
    }
  } else {
    pixel = 0;
  }
}

void borrarTextosMatrizPlanetario() {
  matrix.fillScreen(LOW);
  matrix.write();
}
`;
  generator.setups_.matriz_ciudad_planetario = `
matrix.setIntensity(10);
matrix.setPosition(0, 0, 0);
matrix.setPosition(1, 1, 0);
matrix.setPosition(2, 2, 0);
matrix.setPosition(3, 3, 0);
matrix.setPosition(4, 4, 0);
matrix.setPosition(5, 5, 0);
`;
};

export const matriz_ciudad_planetario = (block, generator) => {
  const velocidad = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC) || 0;
  const texto = generator.valueToCode(block, 'TEXTOIN', generator.ORDER_ATOMIC) || '';
  installMatrizCiudad(generator);
  return `\nescribirMensajeMatrizPlanetario(${texto}, ${velocidad});\n`;
};

export const borrar_matriz_planetario = (block, generator) => {
  installMatrizCiudad(generator);
  return 'borrarTextosMatrizPlanetario();\n';
};

export const math_number_reflector = (block, generator) => {
  const code = block.getFieldValue('SLIDER');
  return [code, generator.ORDER_ATOMIC];
};

const installReflector = (generator) => {
  generator.definitions_.planetario_reflector_init = `
#include <Adafruit_NeoPixel.h>
#define PINREFLECTOR 5
#define NUMPIXELSREFLECTOR 3
Adafruit_NeoPixel pixelsReflector(NUMPIXELSREFLECTOR, PINREFLECTOR, NEO_GRB + NEO_KHZ800);
`;
  generator.setups_.planetario_reflector_begin = `
pixelsReflector.begin();
pixelsReflector.clear();
`;
};

export const planetario_reflector = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  const led = block.getFieldValue('LED') || '0';
  installReflector(generator);
  return `
pixelsReflector.setPixelColor(${led}, pixelsReflector.Color(${color}));
pixelsReflector.show();
delayMicroseconds(300);
`;
};

export const planetario_reflector_off = (block, generator) => {
  const led = block.getFieldValue('LED') || '0';
  installReflector(generator);
  return `
pixelsReflector.setPixelColor(${led}, pixelsReflector.Color(0,0,0));
pixelsReflector.show();
delayMicroseconds(300);
`;
};
